import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "formgrid grid m-0" }
const _hoisted_2 = { class: "col-12 lg:col-6" }
const _hoisted_3 = { class: "p-inputgroup mt-2" }
const _hoisted_4 = { class: "p-inputgroup-addon" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "p-error" }
const _hoisted_7 = { class: "p-inputgroup mt-2" }
const _hoisted_8 = { class: "p-inputgroup-addon" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "p-error" }
const _hoisted_11 = { class: "col-12 lg:col-6" }
const _hoisted_12 = { class: "p-inputgroup mt-2" }
const _hoisted_13 = { class: "p-inputgroup-addon" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-error" }
const _hoisted_16 = { class: "col-12 lg:col-6" }
const _hoisted_17 = { class: "p-inputgroup mt-2" }
const _hoisted_18 = { class: "p-inputgroup-addon" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "p-error" }
const _hoisted_21 = { class: "col-12 lg:col-6" }
const _hoisted_22 = { class: "p-inputgroup mt-2" }
const _hoisted_23 = { class: "p-inputgroup-addon" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "p-error" }
const _hoisted_26 = { class: "col-12 lg:col-6" }
const _hoisted_27 = { class: "p-inputgroup mt-2" }
const _hoisted_28 = { class: "p-inputgroup-addon" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "p-error" }
const _hoisted_31 = { class: "col-12 lg:col-6" }
const _hoisted_32 = { class: "p-inputgroup mt-2" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Attention", -1)
const _hoisted_34 = { class: "col-12 lg:col-6" }
const _hoisted_35 = { class: "p-inputgroup mt-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Email", -1)
const _hoisted_37 = {
  key: 0,
  class: "p-error"
}
const _hoisted_38 = { class: "col-12 lg:col-6" }
const _hoisted_39 = { class: "p-inputgroup mt-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Phone", -1)
const _hoisted_41 = { class: "col-12 lg:col-6" }
const _hoisted_42 = { class: "p-inputgroup mt-2" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, "Fax", -1)
const _hoisted_44 = {
  key: 0,
  class: "grid col-12 lg:col-6 ml-2 mt-2 align-items-center"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { for: "add-address" }, " Save this Address for future use ", -1)
const _hoisted_46 = { class: "grid align-items-center justify-content-between pl-4 pr-2 pt-2 xl:pt-0" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("small", null, "Fields marked with (*) are required", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: _ctx.header,
    visible: _ctx.show,
    "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.show) = $event)),
    style: { width: '800px' },
    modal: true,
    draggable: false,
    class: "p-fluid",
    onHide: _ctx.closeAddressDialog
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createElementVNode("div", null, [
          _createVNode(_component_Button, {
            label: "Cancel",
            icon: "pi pi-times",
            onClick: _ctx.closeAddressDialog
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            label: "Continue",
            icon: "pi pi-check",
            loading: _ctx.isSubmitting,
            onClick: _ctx.saveAddressInfo
          }, null, 8, ["loading", "onClick"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, "Name " + _toDisplayString(!_ctx.newShippingAddress.ship_name ? '*' : ''), 1),
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newShippingAddress.ship_name) = $event)),
              class: _normalizeClass({
              'p-invalid': _ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_name.$invalid,
            })
            }, null, 8, ["modelValue", "class"])
          ]),
          (_ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_name.$invalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.v$.newShippingAddress.ship_name.required.$message), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.newShippingAddress.ship_to_items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "col-12 lg:col-6"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, "Street-" + _toDisplayString(index + 1) + " " + _toDisplayString(_ctx.isValidStreet(index) ? '' : '*'), 1),
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: item.ship_to,
                "onUpdate:modelValue": ($event: any) => ((item.ship_to) = $event)
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              _createVNode(_component_Button, {
                title: "Add Address Line",
                icon: "pi pi-plus",
                class: "text-sm font-bold",
                onClick: ($event: any) => (_ctx.addAddressLine(index))
              }, null, 8, ["onClick"]),
              (index > 0)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    icon: "pi pi-trash",
                    title: "Remove Address Line",
                    class: "text-sm font-bold",
                    onClick: ($event: any) => (_ctx.deleteAddressLine(index))
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.isSubmitted && !_ctx.isValidStreet(index))
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("small", _hoisted_10, _toDisplayString(index === 0 ? `Street ${index + 1} is required` : `Street ${index + 1} should not be empty`), 1)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, "City " + _toDisplayString(!_ctx.newShippingAddress.ship_city ? '*' : ''), 1),
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_city,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newShippingAddress.ship_city) = $event)),
              class: _normalizeClass({
              'p-invalid': _ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_city.$invalid,
            })
            }, null, 8, ["modelValue", "class"])
          ]),
          (_ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_city.$invalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("small", _hoisted_15, _toDisplayString(_ctx.v$.newShippingAddress.ship_city.required.$message), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, "State " + _toDisplayString(!_ctx.newShippingAddress.ship_state ? '*' : ''), 1),
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_state,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newShippingAddress.ship_state) = $event)),
              class: _normalizeClass({
              'p-invalid': _ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_state.$invalid,
            })
            }, null, 8, ["modelValue", "class"])
          ]),
          (_ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_state.$invalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("small", _hoisted_20, _toDisplayString(_ctx.v$.newShippingAddress.ship_state.required.$message), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("span", _hoisted_23, "Zip " + _toDisplayString(!_ctx.newShippingAddress.ship_zip ? '*' : ''), 1),
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_zip,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newShippingAddress.ship_zip) = $event)),
              class: _normalizeClass({
              'p-invalid': _ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_zip.$invalid,
            })
            }, null, 8, ["modelValue", "class"])
          ]),
          (_ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_zip.$invalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.v$.newShippingAddress.ship_zip.required.$message), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("span", _hoisted_28, "Country " + _toDisplayString(!_ctx.newShippingAddress.ship_country ? '*' : ''), 1),
            _createVNode(_component_Dropdown, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_country,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newShippingAddress.ship_country) = $event)),
              options: _ctx.getCountries(),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getCountryCode(_ctx.newShippingAddress.ship_country))),
              panelClass: "w-1",
              class: _normalizeClass({
              'p-invalid': _ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_country.$invalid,
            })
            }, null, 8, ["modelValue", "options", "class"])
          ]),
          (_ctx.isSubmitted && _ctx.v$.newShippingAddress.ship_country.$invalid)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("small", _hoisted_30, _toDisplayString(_ctx.v$.newShippingAddress.ship_country.required.$message), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_attn,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newShippingAddress.ship_attn) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_email,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newShippingAddress.ship_email) = $event)),
              class: _normalizeClass({
              'p-invalid':
                _ctx.isSubmitted &&
                _ctx.newShippingAddress.ship_email &&
                _ctx.emailValidation(_ctx.newShippingAddress.ship_email) === false,
            })
            }, null, 8, ["modelValue", "class"])
          ]),
          (
            _ctx.isSubmitted &&
            _ctx.newShippingAddress.ship_email &&
            _ctx.emailValidation(_ctx.newShippingAddress.ship_email) === false
          )
            ? (_openBlock(), _createElementBlock("small", _hoisted_37, "Value is not a valid email address"))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_phone,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newShippingAddress.ship_phone) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.newShippingAddress.ship_fax,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newShippingAddress.ship_fax) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        (_ctx.addAddressToCustomerSwitch)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              _hoisted_45,
              _createVNode(_component_InputSwitch, {
                id: "add-address",
                modelValue: _ctx.addAddressToCustomer,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.addAddressToCustomer) = $event)),
                class: "ml-2"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["header", "visible", "onHide"]))
}